var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.Opt.isTeam)?_c('div',{staticClass:"GameLayoutOrder"},[(_vm.creditType == 'credit')?_c('credit'):(_vm.creditType == 'formal')?_c('formal'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }